import { lazy, useCallback, useEffect, useMemo } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import OrderFormContainer from '@components/RequisitionCreate/OrderFormContainer/OrderFormContainer';
import { DRAFT_ORDERS } from '@constants/routes';
import useDraftOrderDetail from '@contexts/useDraftOrderDetail';
import { getDraftOrderDetail } from '@store/actions';

const RequisitionJSONSchemaForm = lazy(
  () => import('@components/RequisitionCreate/RequisitionJSONSchemaForm/RequisitionJSONSchemaForm'),
);

export default function DraftOrderDetail() {
  const navigate = useNavigate();
  const params = useParams();
  const draftOrderId = useMemo(() => params?.id, [params]);
  const { draftOrder, setDraftOrder, loading, setLoading } = useDraftOrderDetail();

  const moveToDraftOrders = useCallback(() => {
    navigate(DRAFT_ORDERS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadData = useCallback(async () => {
    if (!draftOrderId) return;

    try {
      setLoading(true);

      const res = await getDraftOrderDetail(draftOrderId);

      setDraftOrder({ ...res });
    } catch (err) {
      console.error('Error on getting a draft order detail: ', err);
    } finally {
      setLoading(false);
    }
  }, [draftOrderId, setDraftOrder, setLoading]);

  const breadcrumbs = useMemo(
    () => [
      {
        onClick: moveToDraftOrders,
        children: 'Draft Orders',
      },
      {
        active: true,
        children: draftOrder?.name ?? '',
      },
    ],
    [moveToDraftOrders, draftOrder],
  );

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (!draftOrder || loading) {
    // TODO: show loading indicator
    return null;
  }

  return (
    <OrderFormContainer breadcrumbs={breadcrumbs} title='Your Draft Order' onCancel={moveToDraftOrders}>
      <RequisitionJSONSchemaForm
        draftFormData={draftOrder.formdata}
        selectedCampaignCode={draftOrder.formdata.campaign_code}
      />
    </OrderFormContainer>
  );
}
